import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import PropTypes from "prop-types";
import FormsContext from "../FormsContext";

const Categories = ({ categories, forms, visible, onChange, onBackClick }) => {
    const [filteredCategories, setFilteredCategories] = useState(categories);
    const { addFormState } = useContext(FormsContext);

    useEffect(() => {
        const filterOnlyParents = (category) => category.parentCategory === null;
        const parentCategories = hasElements(categories) ? categories.filter(filterOnlyParents) : [];
        setFilteredCategories(parentCategories);

        return () => {
            setFilteredCategories([]);
        };
    }, [categories]);

    const renderCategory = (category) => {
        const subCategories = categories.filter((x) => x.parentCategory?.id === category.id) || [];
        const formsInCategory = forms.filter((x) => x.category.id === category.id);
        return (
            <>
                <Card
                    onClick={() => onChange(category)}
                    className={clsx({
                        selected: category.id === addFormState.category?.id,
                    })}
                >
                    <span>
                        <strong>{category.category}</strong>
                        <small>{`  (${formsInCategory.length})`}</small>
                    </span>
                    <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                </Card>
                <div className="sub-categories">
                    {subCategories.map((subCategory) => (
                        <Fragment key={subCategory.id}>{renderCategory(subCategory)}</Fragment>
                    ))}
                </div>
            </>
        );
    };

    return (
        <div
            className={clsx("layout categories-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>Category</h3>
                    <small>
                        <i>Select a category to view forms</i>
                    </small>
                    <div className="categories">
                        {filteredCategories.map((category) => (
                            <Fragment key={category.id}>{renderCategory(category)}</Fragment>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            category: PropTypes.string,
            description: PropTypes.string,
            parentCategory: PropTypes.shape({
                id: PropTypes.string,
                category: PropTypes.string,
            }),
        })
    ),
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    selected: PropTypes.shape({
        id: PropTypes.string,
        category: PropTypes.string,
        description: PropTypes.string,
        parentCategory: PropTypes.shape({
            id: PropTypes.string,
            category: PropTypes.string,
        }),
    }),
    onBackClick: PropTypes.func,
    forms: PropTypes.array,
};

Categories.defaultProps = {
    categories: [],
    visible: true,
    onChange: () => {},
    selected: null,
    onBackClick: () => {},
    forms: [],
};

export default Categories;
